import {getCookie} from "../../../../../static/js/getCookie";

export const fetchOddsmatcherData = async (type = 'normal') => {
    const apiUrl = type === 'bog'
        ? '/tools/api/bogmatcher/'
        : type === 'ew'
            ? '/tools/api/each-way-matcher/'
            : type === 'ep'
                ? '/tools/api/extra-place-matcher/'
                : '/tools/api/oddsmatcher/'
    const csrfToken = getCookie('csrftoken');
    const url = location.protocol + '//' + location.host + apiUrl;
    try {
        const response = await fetch(url, {
            method: "GET",
            mode: "cors",
            cache: "no-cache",
            credentials: "same-origin",
            headers: {
                "Content-Type": "application/json",
                'X-CSRFToken': csrfToken,
            },
            redirect: "follow",
            referrerPolicy: "no-referrer",
        });
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        return response.json();
    } catch (error) {
        console.error('Fetch error:', error);
        throw error; // Re-throw to handle it in the component
    }
};

